import { render, staticRenderFns } from "./veStuIdxStuScore.vue?vue&type=template&id=5342d96c&scoped=true"
import script from "./veStuIdxStuScore.vue?vue&type=script&lang=js"
export * from "./veStuIdxStuScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5342d96c",
  null
  
)

export default component.exports